module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-point"
  }, [_c('h3', {
    staticClass: "page-title2"
  }, [_vm._v("服务网点维护")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.handleOpenDialog()
      }
    }
  }, [_vm._v("新增服务网点")]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "网点类型"
    }
  }, [_c('el-select', {
    staticClass: "item-input",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "在行无人银行/离行无人银行/网点营业厅",
      "clearable": ""
    },
    model: {
      value: (_vm.Search.PosType),
      callback: function($$v) {
        _vm.Search.PosType = $$v
      },
      expression: "Search.PosType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "在行无人银行",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "离行无人银行",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "网点营业厅",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备类型"
    }
  }, [_c('el-select', {
    staticClass: "item-input",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "现金自助设备/非现金自助设备",
      "clearable": ""
    },
    model: {
      value: (_vm.Search.PosDeviceType),
      callback: function($$v) {
        _vm.Search.PosDeviceType = $$v
      },
      expression: "Search.PosDeviceType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "现金自助设备",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非现金自助设备",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "网点编号"
    }
  }, [_c('el-input', {
    staticClass: "item-input",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "请输入网点编号"
    },
    model: {
      value: (_vm.Search.Code),
      callback: function($$v) {
        _vm.Search.Code = $$v
      },
      expression: "Search.Code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地区"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "options": _vm.Provinces,
      "props": {
        value: 'Id',
        label: 'Name',
        children: 'children'
      },
      "placeholder": "请选择地区（省/市）",
      "clearable": ""
    },
    on: {
      "active-item-change": _vm.handleItemChange
    },
    model: {
      value: (_vm.Search.Place),
      callback: function($$v) {
        _vm.Search.Place = $$v
      },
      expression: "Search.Place"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机器编码"
    }
  }, [_c('el-input', {
    staticClass: "item-input",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "请输入机器编码"
    },
    nativeOn: {
      "click": function($event) {
        _vm.getPoint($event)
      }
    },
    model: {
      value: (_vm.Search.AtmCode),
      callback: function($$v) {
        _vm.Search.AtmCode = $$v
      },
      expression: "Search.AtmCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPoint
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "data": _vm.Points
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "color": "#7f8fa4"
          }
        }, [_vm._v("ATM机数量：")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#354052"
          }
        }, [_vm._v(_vm._s(props.row.PosAtmListJson.length) + "个（ " + _vm._s(props.row.PosAtmListJson.join('，')) + "）")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "网点编号",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "网点类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("PosType")(props.row.PosType)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "设备类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("PosDeviceType")(props.row.PosDeviceType)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "网点地址",
      "prop": "StreetAddress"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handleOpenDialog(props.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticClass: "danger",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handleRemoveItem(props.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('point-dialog', {
    attrs: {
      "name": "point",
      "Banks": _vm.Banks,
      "show": _vm.PointDialog.show,
      "title": _vm.PointDialog.Form.Id ? '编辑网点' : '新增网点',
      "form": _vm.PointDialog.Form
    },
    on: {
      "update:show": function($event) {
        _vm.PointDialog.show = $event
      },
      "confirm": _vm.handlePointConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7226e024"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ProfilePage/CustomerPointModule.vue
// module id = 752
// module chunks = 0